<div class="flex flex-col p-4 sm:p-8 font-display">
  <div class="w-full flex items-center justify-between">
    <span class="text-base sm:text-lg font-semibold">File Preview</span>
    <button (click)="closeDialog()" class="rounded-full p-1">
      <i
        class="fa-solid fa-xmark text-lg sm:text-xl text-gray-400 hover:text-gray-600"
      ></i>
    </button>
  </div>

  <div class="w-full h-full mt-6">
    @if (fileUrl && isPdf) {
    <iframe
      [src]="fileUrl"
      class="w-full h-[60vh] sm:h-[70vh]"
      style="border: none"
    ></iframe>
    } @else if (fileUrl && isImage) {
    <img
      [src]="fileUrl"
      alt="File Preview"
      class="max-h-[60vh] sm:max-h-[70vh] mx-auto"
    />
    } @else {
    <p>Sedang memuat file...</p>
    }
  </div>

  <div class="w-full flex flex-col sm:flex-row items-center justify-end gap-2 mt-4">
    <button
      (click)="closeDialog()"
      class="w-full sm:w-80 h-12 rounded-lg bg-gray-400 text-white flex items-center justify-center space-x-2"
    >
      <span>Close</span>
    </button>
    <button
      (click)="download()"
      class="w-full sm:w-80 h-12 rounded-lg bg-[#42A5CE] text-white flex items-center justify-center space-x-2"
    >
      <i class="fa-solid fa-download"></i>
      <span>Download</span>
    </button>
  </div>
</div>
